module.exports = __webpack_public_path__ + "static/media/karin_photo.2c7fb130.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPg/ImageCarousel/images/karin_photo.jpg
// module id = 1395
// module chunks = 0 1 2 3